<template>
  <div class="search-input-box table-filter-item">
    <el-input
      ref="listSearchInput"
      :class="`search-input search-input-${size}`"
      v-model="keywords"
      :placeholder="placeholder"
      @keyup.enter.native="handleSearch"
      :size="size"
      enterkeyhint="search"
    />

    <el-button
      icon="el-icon-search"
      @click="handleSearch"
      :size="size"
      type="primary"
    >
      搜索
    </el-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: String,
    size: {
      type: String,
      default: 'medium',
    },
  },
  data: () => ({
    keywords: '',
  }),
  watch: {
    value(e) {
      if (e !== this.keywords) this.keywords = e;
    },
    keywords(e) {
      this.$emit('input', e);
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
  },
  methods: {
    handleSearch() {
      this.$emit('search');
      if (this.isMobile) this.$refs.listSearchInput.blur();
    },
  },
};
</script>

<style scoped>
  .search-input-box >>> .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }
  .search-input-box >>> .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .search-input {
    width: 300px;
  }

  .search-input-small {
    width: 230px;
  }
</style>
